import { makeCommaDelimitedSentenceFragment } from 'src/utilities/stringUtils';
import type { ManagedDocumentTemplate } from 'src/components/dialogs/ManageDocumentTemplatesDialog.vue';
import type { Token } from 'src/components/form-controls/tokenUtils';

function getDocumentTemplateDefaultDescription(doc: ManagedDocumentTemplate, encryptEntries: boolean, isMultiPageForm: boolean, isPaymentForm: boolean) {
	let description = doc.Description || '';

	// If there is no description, use a default
	if (!description) {
		if (doc.DocumentMode === 'Custom') {
			description = 'Custom template.';
		}
		else {
			if (doc.IncludeEntryDetails) {
				const detailItems = [];

				if (doc.IncludeBlankFields) detailItems.push('blank');
				if (doc.IncludeInternalFields) detailItems.push('internal');
				if (doc.IncludeHiddenFields) detailItems.push('hidden');
				if (encryptEntries && doc.IncludeProtectedFields) detailItems.push('protected');

				if (detailItems.length > 0) {
					if (doc.includeFormControls) {
						detailItems.splice(0, 0, 'form controls');
					}
					description = 'Details with ' + makeCommaDelimitedSentenceFragment(detailItems, true, '&') + ' fields.';
				}
				else if (doc.DocumentMode === 'Edit') {
					description = 'Details with form controls.';
				}
				else {
					description = 'Details.';
				}
			}

			const otherItems = [];

			if (doc.IncludeLogo) otherItems.push('logo');
			if (doc.IncludeTitle) otherItems.push('title');
			if (doc.IncludePageNumbers) otherItems.push('page numbers');

			if (isMultiPageForm) {
				if (doc.IncludePageBreaks) otherItems.push('page breaks');
				if (doc.IncludePageTitles) otherItems.push('page titles');
			}

			if (isPaymentForm) {
				if (doc.IncludePaymentDetails) otherItems.push('payment details');
			}

			if (otherItems.length > 0) {
				const listItems = [];
				listItems.push(otherItems[0][0].toUpperCase() + otherItems[0].substring(1));
				Array.prototype.push.apply(listItems, otherItems.slice(1));
				description += (description.length > 0 ? ' ' : '') + makeCommaDelimitedSentenceFragment(listItems, true, '&') + '.';
			}

			if (!description)
				description = 'Blank document.';
		}
	}

	return description;
}

export type TokenizeHtmlFunction = (html: string, currentElement?, parentIndex?: number, textToHtml?: boolean, tokens?: Token[]) => string;

export function setDocumentTemplateDefaultValues(doc: ManagedDocumentTemplate, formTitle: string, encryptEntries: boolean, isMultiPageForm: boolean, isPaymentForm: boolean, tokenizeHtml: TokenizeHtmlFunction, tokens: Token[]) {
	// If there is no name, use a default
	doc.name = doc.Name || formTitle + ' - [Entry.Number]';
	// If there is no tokenized html, generate it
	doc.NameHtml = doc.NameHtml || tokenizeHtml(doc.name, null, null, false, tokens);

	doc.description = getDocumentTemplateDefaultDescription(doc, encryptEntries, isMultiPageForm, isPaymentForm);

	return doc;
}